import {prop} from "ramda";
import {saveSlugsFromRels} from "../../features/stories/interceptors";
import API from "..";

const getStoryBySlug = slug =>
  API.News.getStoryBySlug({slug}).then(prop("data")).then(saveSlugsFromRels);

export default getStoryBySlug;
